import SmoothScroll from 'smooth-scroll';
import Tabby from 'tabbyjs';
import './modules/core/header/navigation.main.js';
import './modules/content/accordion.js'; import './modules/content/layout/lang.js'; import './modules/content/layout/masonry.js'; import './modules/content/maps.js'; import './modules/content/media/carousel.js'; import './modules/content/media/swiper.js';
import './modules/form/file.js'; import './modules/form/input.js'; import './modules/form/select.js';

/* window object / functions
   ========================================================================== */

window.ScrollLock = require('./util/scrollLock');

/* General
   ========================================================================== */

window.addEventListener('load', () => {
  const html = document.querySelector('html')
  html.classList.remove('preload')

  // https://github.com/cferdinandi/smooth-scroll
  new SmoothScroll('.navigation--anchor a[href*="#"]', {
    header: '.navigation--anchor',
    updateURL: false
  });


  const scrollNextTargets = document.querySelectorAll('.scroll-to-next')
  for (let i = 0; i < scrollNextTargets.length; i++) {
    const target = scrollNextTargets[i]
    const parent = target.closest('header, section')
    const nextSection = getNextSibling(parent)

    target.addEventListener('click', function () {
      var scroll = new SmoothScroll();
      var toggle = 0
      var options = {
        easing: 'easeOutCubic',
        header: '.o-navigation--main',
        speed: 2000
      };
      scroll.animateScroll(nextSection, toggle, options);
    })
  }

  // Tabby: https://github.com/cferdinandi/tabby
  const elTabs = document.querySelector('[data-tabs')
  if (elTabs) {
    new Tabby('[data-tabs]', {
      default: '.is-default'
    });
  }

  const openModal = document.querySelector('.open-form')
  if (openModal) {
    openModal.addEventListener('click', function () {
      this.classList.add('active')
    })
  }

  const targets = document.querySelectorAll('.related-processlines [data-target]')
  targets.forEach((el) => {
    el.addEventListener('mouseenter', () => {
      const index = el.getAttribute('data-target')
      const images = document.querySelectorAll('.related-processlines [data-image]')

      images.forEach((image) => {
        image.style.display = 'none'

				if(image.dataset.image === index) {
					image.style.display = 'block'
				}
      })

      targets.forEach((target) => {
        target.classList.remove('is-current')
      })

			el.classList.add('is-current')
    })
  })


	const englishFormButton = document.querySelector('.english-button .inf__drop-area .inf__hint');

	if(englishFormButton) {
		englishFormButton.innerHTML = 'Upload file';
	}

})

const accordionMachines = document.querySelectorAll('.collapsed-button');
const collapsedContent = document.querySelector('#collapsed-content');

accordionMachines.forEach( (el) => {
	el.addEventListener('click', () => {

		let toggleText = el.dataset.toggleText;
		if (toggleText) {
			el.dataset.toggleText = el.textContent;
			el.textContent = toggleText;
		} else {
			el.classList.add('hidden');
		}

		collapsedContent.classList.toggle('!max-h-full');
	})
})


const getNextSibling = function (elem, selector) {
  let sibling = elem.nextElementSibling;

  if (!selector) return sibling;
  while (sibling) {
    if (sibling.matches(selector)) return sibling;
    sibling = sibling.nextElementSibling
  }
}
